export default __webpack_public_path__ + "static/media/Upload.4216d613.svg";